import type { TFunction } from 'i18next'

import { isStartpage } from '../utils'
import AddCategoryPanel from './AddCategoryPanel'
import FormGroup from '../../formComponents/FormGroup'
import InfoGroup from '../../formComponents/InfoGroup'
import InputField from '../../formComponents/InputField'
import RadioButtonField from '../../formComponents/RadioButtonField'
import SelectPageLevelPanel from './SelectPageLevel/SelectPageLevelPanel'

type PageCreatePanelProps = {
  isBeyondShop: boolean
  tModal: TFunction
  changedPage: ImmutableMap
  categories: ImmutableList
}

export function PageCreatePanel({ categories, changedPage, isBeyondShop, tModal }: Readonly<PageCreatePanelProps>) {
  return (
    <>
      <FormGroup
        key="pageName"
        tagName="label"
        name="title"
        label={tModal('pageNameInputField.label') + '*'}
        title={tModal('pageNameInputField.tooltip')}
      >
        <InputField name="title" type="text" maxLength={100} />
      </FormGroup>

      {isBeyondShop && <AddCategoryPanel t={tModal} {...{ categories }} />}

      <FormGroup key="visibility" name="isVisible" label={tModal('visibilitySection.title')}>
        <InfoGroup info={tModal('visibilitySection.hideRadioButton.explanation')}>
          <RadioButtonField
            name="isVisible"
            buttons={[
              {
                label: tModal('visibilitySection.showRadioButton.label'),
                value: true,
              },
              {
                label: tModal('visibilitySection.hideRadioButton.label'),
                value: false,
              },
            ]}
          />
        </InfoGroup>
      </FormGroup>

      <div className="ep-form-row">
        <div className="ep-form-row-label">
          <span className="ep-form-row-label-text">{tModal('navigationSection.title')}</span>
          <div>
            {isStartpage(changedPage) && (
              <p className="ep-form-row-text">{tModal('navigationSection.startpageNotMovableExplanation')}</p>
            )}
            <RadioButtonField
              disabled={isStartpage(changedPage)}
              name="navigation"
              buttons={[
                {
                  label: tModal('navigationSection.mainMenuRadioButton.label'),
                  value: 'main',
                },
                {
                  label: tModal('navigationSection.footerMenuRadioButton.label'),
                  value: 'footer',
                },
              ]}
            />
          </div>
        </div>
      </div>
      {changedPage.get('navigation') === 'main' && <SelectPageLevelPanel />}
    </>
  )
}
